export function Privacy() {
  return (
    <div className="mx-auto flex w-full max-w-[420px] flex-col gap-4 px-5 py-6 text-sm text-ivory/85">
      <h1 className="heading-display text-3xl">Политика конфиденциальности</h1>
      <p className="text-xs text-ivory/55">Действует с 27 апреля 2026 г.</p>

      <Section title="Кто мы">
        <p>
          durakapp — Telegram Mini App для игры в подкидного дурака между реальными игроками. Сервис
          доступен по адресу <strong>durakapp.nexaweb.su</strong> и через бота{' '}
          <strong>@durakapp_game_bot</strong>.
        </p>
      </Section>

      <Section title="Какие данные мы собираем">
        <ul className="ml-4 list-disc space-y-1">
          <li>
            <strong>Из Telegram initData</strong> — Telegram ID, имя, username (если открыт),
            URL аватара, язык. Это всё, что Telegram передаёт нам при запуске Mini App.
          </li>
          <li>
            <strong>Игровые события</strong> — стейт партий, история ходов, рейтинг (ELO),
            счётчики побед и поражений. Хранится только то, что нужно для разрешения споров.
          </li>
          <li>
            <strong>Финансовые транзакции</strong> — покупка фишек (Telegram Stars / USDT /
            TON / BTC / ETH через @CryptoBot или напрямую TON), внутриигровые ставки и
            выплаты, выводы. Идентификатор внешнего платежа (TG-charge_id, CryptoBot
            invoice_id, TON-transfer hash) сохраняется для идемпотентности.
          </li>
          <li>
            <strong>Технические логи</strong> — IP-адрес, user-agent, время событий. Хранятся
            не дольше 30 дней и используются только для отладки и противодействия мошенничеству.
          </li>
        </ul>
      </Section>

      <Section title="Зачем нам эти данные">
        <ul className="ml-4 list-disc space-y-1">
          <li>Авторизация и идентификация игрока в матчмейкере.</li>
          <li>Подсчёт рейтинга, истории, статистики.</li>
          <li>Конвертация фишек в крипту/Stars при выводе и удержание комиссии 10%.</li>
          <li>Проверка честности партий по детерминированной записи ходов.</li>
        </ul>
      </Section>

      <Section title="Кому мы передаём данные">
        <p>
          Никому, кроме платёжных провайдеров: Telegram (Bot API + Stars API), @CryptoBot
          (Crypto Pay API) и TON blockchain (адрес кошелька — публичен по природе сети).
          Мы не продаём данные и не делимся ими с рекламными сетями.
        </p>
      </Section>

      <Section title="Хранение и удаление">
        <p>
          Финансовые транзакции и финальные результаты партий храним 3 года — этого требует
          возможный разбор споров и налоговая отчётность. Технические логи — до 30 дней.
          Чтобы удалить аккаунт и связанные данные, напишите в поддержку (см. ниже).
        </p>
      </Section>

      <Section title="Безопасность">
        <p>
          Соединение защищено TLS. Stars-платежи проходят полностью внутри Telegram,
          CryptoBot-платежи — внутри @CryptoBot, TON-переводы — публично в блокчейне.
          Реквизитов банковских карт у нас нет. Балансовые операции выполняются в
          SERIALIZABLE-транзакциях с защитой от двойного зачисления.
        </p>
      </Section>

      <Section title="Контакт">
        <p>
          По вопросам данных и удаления аккаунта пишите в Telegram:{' '}
          <a href="https://t.me/durakapp_game_bot" className="text-gold underline">
            @durakapp_game_bot
          </a>
          .
        </p>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="flex flex-col gap-2">
      <h2 className="heading-display text-xl text-gold">{title}</h2>
      {children}
    </section>
  );
}
